{
  "decrease": "{fieldLabel} csökkentése",
  "increase": "{fieldLabel} növelése",
  "numberField": "Számmező"
}
